export var RadioGroupLayout;
(function (RadioGroupLayout) {
    RadioGroupLayout["Block"] = "Block";
    RadioGroupLayout["Stack"] = "Stack";
    RadioGroupLayout["Inline"] = "Inline";
    RadioGroupLayout["InlineFlex"] = "InlineFlex";
    RadioGroupLayout["InlineEqualWidth"] = "InlineEqualWidth";
})(RadioGroupLayout || (RadioGroupLayout = {}));
export var RadioGroupCssClass;
(function (RadioGroupCssClass) {
    RadioGroupCssClass["Base"] = "iress-radio-group";
    RadioGroupCssClass["Block"] = "iress-radio-group--block";
    RadioGroupCssClass["Stack"] = "iress-radio-group--stack";
    RadioGroupCssClass["Inline"] = "iress-inline iress-radio-group--inline";
    RadioGroupCssClass["InlineFlex"] = "iress-inline iress-radio-group--inline iress-radio-group--inline-flex";
    RadioGroupCssClass["InlineEqualWidth"] = "iress-inline iress-radio-group--inline iress-radio-group--inline-ew";
})(RadioGroupCssClass || (RadioGroupCssClass = {}));
//# sourceMappingURL=radio-group.types.js.map